import axios from 'axios';
const baseURL = import.meta.env.VITE_BASE_URL; // e.g., 'https://localhost:4000/api/v1'

const apiClient = axios.create({
    baseURL: `${baseURL}/auth`, //https://localhost:4000/api/v1/auth
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    },
});


export default {

    async login(credentials) {
        const response = await apiClient.post('/login', credentials);
        return response.data;
    },

    async register(userInfo) {
        const response = await apiClient.post('/register', userInfo);
        return response.data;
    },

    async logout() {
        const response = await apiClient.post('/logout');
        return response.data;
    },

    async refreshToken() {
        const response = await apiClient.post('/refresh-token');
        return response.data;
    }   
}
